module.exports = __webpack_public_path__ + "static/media/21ECLAC7.896f70b6.jpg";